/** Silêncio após texto antes de chamar a IA (chat /central-ia). */
export const SUPPORT_ASSISTANT_COMPOSE_IDLE_MS = 4500;
/** Silêncio maior após anexo (cliente costuma mandar print + texto em seguida). */
export const SUPPORT_ASSISTANT_COMPOSE_MEDIA_IDLE_MS = 6500;
/** Teto desde a primeira mensagem do lote. */
export const SUPPORT_ASSISTANT_COMPOSE_MAX_MS = 120_000;

export function computeSupportAssistantComposeDelayMs(params: {
  firstAt: number;
  now?: number;
  hasMedia: boolean;
}): number {
  const now = params.now ?? Date.now();
  const idle = params.hasMedia ? SUPPORT_ASSISTANT_COMPOSE_MEDIA_IDLE_MS : SUPPORT_ASSISTANT_COMPOSE_IDLE_MS;
  const remaining = SUPPORT_ASSISTANT_COMPOSE_MAX_MS - (now - params.firstAt);
  return Math.max(0, Math.min(idle, remaining));
}
